import { RateBoostLimitCard } from "./RateBoostLimitCard";
import { SpendLimitWarning } from "./SpendLimitWarning";

interface BoostSpendLimitCardProps {
  isAdmin: boolean;
  overageInMinorUnits: number;
  limitInMinorUnits: number | undefined;
  isRequested?: boolean;
  onRequestIncrease?: () => void;
  weekRange?: string;
}

/**
 * Single source of truth for the over-limit boost card's admin/workplace split, so every charge-editing
 * surface renders it the same way: admins see the non-blocking `SpendLimitWarning`, workplace users see the
 * blocking `RateBoostLimitCard` (with the request-increase action). Callers still gate their own Save/Send
 * on `!isAdmin` — admins are warned here, never blocked.
 */
export function BoostSpendLimitCard({
  isAdmin,
  overageInMinorUnits,
  limitInMinorUnits,
  isRequested,
  onRequestIncrease,
  weekRange,
}: BoostSpendLimitCardProps) {
  if (isAdmin) {
    return (
      <SpendLimitWarning
        overageInMinorUnits={overageInMinorUnits}
        limitInMinorUnits={limitInMinorUnits}
      />
    );
  }

  return (
    <RateBoostLimitCard
      overageInMinorUnits={overageInMinorUnits}
      isRequested={isRequested}
      onRequestIncrease={onRequestIncrease}
      weekRange={weekRange}
    />
  );
}
